angular.module('app.gamesOfTheWeek.gamesOfTheWeekService', [])
  .factory('app.gamesOfTheWeek.gamesOfTheWeekService', [
    '$http',
    function ($http) {
      "use strict";

      let service = {
        list: null,
        date: null,
        error: null,
        retrieve: function () {
          return $http.get(window.location.api('schedule/games_of_the_week'))
            .then(function (response) {
              let data = response.data;

              service.list = null;
              service.error = null;

              if (data.error) {
                service.error = data.error;
              }
              else {
                service.list = data.games;
                service.date = {
                  start: new Date(data.date.start),
                  end: new Date(data.date.end)
                };
              }
            })
        }
      };

      return service;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/gamesOfTheWeek/gamesOfTheWeekService.js